import { Panel } from '@atlaskit/navigation-system/layout/panel';
import { PanelSplitter } from '@atlaskit/navigation-system/layout/panel-splitter';

import { type UpdatePref } from 'src/hooks/use-pref';
import { type Site } from 'src/redux/jira/types';
import { RovoConversationAssistant } from 'src/sections/global/components/chat-sidebar';

import { useRovoChatContext } from '../nav-system';

type NavSystemPanelProps = {
  rovoEnabledSites: Site[];
  updateRovoPreferredSite: UpdatePref;
};

export function NavSystemPanel(props: NavSystemPanelProps) {
  const { chatState, setChatState } = useRovoChatContext();

  return (
    <Panel defaultWidth={439}>
      <RovoConversationAssistant
        chatState={chatState}
        rovoEnabledSites={props.rovoEnabledSites}
        setChatState={setChatState}
        updateSitePref={props.updateRovoPreferredSite}
      />
      <PanelSplitter label="" />
    </Panel>
  );
}
